export default "__VITE_ASSET__D4L$12z$__"